var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.18.1@lodash/_Symbol.js
// module id = 246
// module chunks = 0